"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.validatorDefaultCatch = validatorDefaultCatch;
var _dialog = require("vue-ydui/dist/lib.rem/dialog");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var dialog = {
  confirm: _dialog.Confirm,
  alert: _dialog.Alert,
  toast: _dialog.Toast,
  notify: _dialog.Notify,
  loading: _dialog.Loading
};
var icons = {
  error: '操作失败',
  success: '操作成功'
};
Object.keys(icons).reduce(function (dialog, key) {
  dialog[key] = function (mes) {
    var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new Promise(function (resolve) {
      (0, _dialog.Toast)(_objectSpread({
        mes: mes || icons[key],
        timeout: 1000,
        icon: key,
        callback: function callback() {
          resolve();
        }
      }, obj));
    });
  };
  return dialog;
}, dialog);
dialog.message = function () {
  var mes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '操作失败';
  var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new Promise(function (resolve) {
    (0, _dialog.Toast)(_objectSpread({
      mes: mes,
      timeout: 1000,
      callback: function callback() {
        resolve();
      }
    }, obj));
  });
};
dialog.validateError = function () {
  validatorDefaultCatch.apply(void 0, arguments);
};
function validatorDefaultCatch(err) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'message';
  console.log(err);
  return dialog[type](err.errors[0].message);
}
var _default = exports.default = dialog;